import { branch, compose, withContext, withProps } from 'recompose'
import moment from 'moment'
import { connect } from 'react-redux'
import { injectIntl } from 'react-intl'
import PropTypes from 'prop-types'
import { get } from 'lodash'
import { withQueryParams } from 'src/composables'
import {
  selectCustomerProfile,
  selectCustomerIsREA,
  selectCustomerFirstName
} from 'src/store/selectors/customerProfile'
import { selectInstantOfferEnabled } from 'src/store/selectors/powerUps'
import {
  selectHomeValue,
  selectWarnings
} from 'src/store/selectors/home/metadata'
import { selectHasCMA, selectLastCMADate } from 'src/store/selectors/home/cma'
import { selectCurrentAVMMap } from 'src/store/selectors/homePreview'
import {
  selectHomeId,
  selectHomeData,
  selectLatestTunedSource
} from 'src/store/selectors/home'
import { selectHomeFactsProgress } from 'src/store/selectors/valuation'
import { selectClientId } from 'src/store/selectors/client'
import { redrawHeightFadeKey } from 'src/actions/transitions'

const defaultProps = withProps(props => ({
  withCurrentHomeData: get(props, 'withCurrentHomeData', false),
  locked: false
}))

const provideContext = withContext(
  { withCurrentHomeData: PropTypes.bool, locked: PropTypes.bool },
  ({ withCurrentHomeData, locked }) => ({ withCurrentHomeData, locked })
)

const composeWithHomeData = compose(
  connect(
    state => ({
      ...selectWarnings(state),
      customerProfile: selectCustomerProfile(state) || {},
      instantOfferEnabled: selectInstantOfferEnabled(state),
      customerIsREA: selectCustomerIsREA(state),
      hasCMA: selectHasCMA(state),
      cmaDate: selectLastCMADate(state),
      homeValue: selectHomeValue(state),
      home: selectHomeData(state),
      homeId: selectHomeId(state),
      clientId: selectClientId(state),
      latestTuneSource: selectLatestTunedSource(state),
      customerFirstName: selectCustomerFirstName(state),
      homeFactsProgress: selectHomeFactsProgress(state)
    }),
    dispatch => ({
      redrawHeightFade: (id, speed) => dispatch(redrawHeightFadeKey(id, speed))
    })
  ),
  withProps(({ customerIsREA }) => ({
    showAvatarOnVerifyButton: customerIsREA
  })),
  injectIntl
)

const composeWithoutHomeData = compose(
  withQueryParams,
  connect((state, { id }) => {
    const avm = selectCurrentAVMMap(state)[id]

    return {
      customerProfile: selectCustomerProfile(state) || {},
      hasCMA: false,
      cmaDate: moment(),
      instantOfferEnabled: false,
      homeValue: get(avm, 'amount')
    }
  })
)

const EstimatedValueContainer = compose(
  defaultProps,
  provideContext,
  branch(
    ({ withCurrentHomeData }) => withCurrentHomeData,
    composeWithHomeData,
    composeWithoutHomeData
  )
)

export default EstimatedValueContainer
